import { CircularProgress, Link } from "@mui/material";
import type React from "react";
import type { ExpirableFileOpenerProps } from "../model";

export const ExpirableFileOpenerUi: React.FC<ExpirableFileOpenerProps> = ({
  filename,
  handleClick,
  isLoading,
}) => {
  return (
    <Link
      component="button"
      onClick={handleClick}
      disabled={isLoading}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        textDecoration: "underline",
        cursor: isLoading ? "wait" : "pointer",
        "&:hover": {
          textDecoration: "underline",
        },
      }}
    >
      {isLoading && <CircularProgress size={16} />}
      {filename}
    </Link>
  );
};
